import React, { useMemo, useState } from 'react';
import { addDays, format } from 'date-fns';
import { CheckCircle2Icon, InfoIcon, PhoneIcon } from 'lucide-react';
import { business, services } from '../data/site';
const timeSlots = ['8:00 AM', '8:30 AM', '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM'];

// Slots already requested by other customers close out until the team confirms.
const closedSlots = ['9:00 AM', '10:30 AM', '2:00 PM'];
export function AppointmentRequest() {
  const earliest = useMemo(() => addDays(new Date(), 2), []);
  const dateOptions = useMemo(() => Array.from({
    length: 10
  }, (_, i) => addDays(earliest, i)).filter(d => d.getDay() !== 0 && d.getDay() !== 6), [earliest]);
  const [date, setDate] = useState(format(dateOptions[0], 'yyyy-MM-dd'));
  const [slot, setSlot] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="request" className="w-full bg-ink py-20 text-white lg:py-28" data-id="element-12" data-mp="2yo7dqp0uzu5a">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-13" data-mp="33lpcjml5wszk">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)] lg:gap-16" data-id="element-14" data-mp="37odqg8oqgq3e">
          <div data-id="element-15" data-mp="3cngjeurfv5v0">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-16" data-mp="3cnqe2vnfi171">
              Two ways to get on the schedule
            </p>
            <h2 className="mt-4 font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] sm:text-[42px]" data-id="element-17" data-mp="3hkp5v7jmdw22">
              Fastest answer? Call the shop.
            </h2>
            <p className="mt-5 text-[16.5px] leading-relaxed text-chalk/70" data-id="element-18" data-mp="3rbtiw1pqj6u9">
              Percy and the team answer the phone during business hours and can
              tell you right away what your vehicle likely needs and when we
              can get it in.
            </p>

            <a href={business.phoneHref} className="mt-7 inline-flex w-full items-center justify-center gap-3 whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:w-auto" data-id="element-19" data-mp="20bthgyeicnm2">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-20" data-mp="25935c9m90r7s" />
              Call {business.phone}
            </a>

            <dl className="mt-9 space-y-3 border-t border-white/10 pt-7 text-[15px]" data-id="element-21" data-mp="2k0vhkcqqxp5a">
              <div className="flex justify-between gap-6" data-id="element-22" data-mp="2ezek6r7h0ktg">
                <dt className="text-chalk/55" data-id="element-23" data-mp="2szpbtwglu3fo">Shop hours</dt>
                <dd className="text-right font-medium" data-id="element-24" data-mp="2sx315nyf37t8">
                  Mon – Fri, 8:00 AM – 5:00 PM
                </dd>
              </div>
              <div className="flex justify-between gap-6" data-id="element-25" data-mp="ymhcbrhop3np">
                <dt className="text-chalk/55" data-id="element-26" data-mp="tmcu9x14o0vd">Mobile</dt>
                <dd className="text-right font-medium" data-id="element-27" data-mp="tnwajnmsabx5">
                  <a href={business.mobileHref} className="hover:text-brand-light" data-id="element-28" data-mp="359ydghnabw0w">
                    {business.mobile}
                  </a>
                </dd>
              </div>
              <div className="flex justify-between gap-6" data-id="element-29" data-mp="2whd1bke5snl1">
                <dt className="text-chalk/55" data-id="element-30" data-mp="2wgv5upzbmde6">Email</dt>
                <dd className="break-all text-right font-medium" data-id="element-31" data-mp="30igf81cnc9jm">
                  <a href={`mailto:${business.email}`} className="hover:text-brand-light" data-id="element-32" data-mp="30gvnejhpv4pg">
                    {business.email}
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <div className="rounded-xl border border-white/10 bg-charcoal p-6 sm:p-8 lg:p-10" data-id="element-33" data-mp="2dkbt7qpb67cv">
            {submitted ? <div className="flex min-h-[420px] flex-col items-start justify-center" data-id="element-34" data-mp="2hlxcbtsfrhvi">
                <CheckCircle2Icon className="h-10 w-10 text-brand-light" aria-hidden="true" data-id="element-35" data-mp="bp1fb8uh8oan" />
                <h3 className="mt-5 font-display text-2xl font-bold tracking-tight" data-id="element-36" data-mp="3n7r0x6t4t74u">
                  Request received
                </h3>
                <p className="mt-3 max-w-[440px] text-[15.5px] leading-relaxed text-chalk/70" data-id="element-37" data-mp="3i95yr1ubkddr">
                  We have held {slot ? `the ${slot} slot on ` : 'your preferred time on '}
                  {format(new Date(`${date}T12:00:00`), 'EEEE, MMMM d')} while
                  we review it. A team member will follow up to confirm your
                  appointment. Need it sooner? Call {business.phone}.
                </p>
                <button type="button" onClick={() => setSubmitted(false)} className="mt-7 rounded-md border border-white/20 px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60" data-id="element-38" data-mp="2uitjt70npgdo">
                  Submit another request
                </button>
              </div> : <form onSubmit={handleSubmit} noValidate={false} data-id="element-39" data-mp="w19w5c0biknu">
                <h3 className="font-display text-[26px] font-bold tracking-tight" data-id="element-40" data-mp="w0qfdymem2be">
                  Request an appointment
                </h3>
                <p className="mt-2 flex items-start gap-2 text-[14px] leading-relaxed text-chalk/60" data-id="element-41" data-mp="1516fqz7uotc1">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-42" data-mp="1a1avuo4ujm1q" />
                  This is a request, not a confirmed booking. Please request at
                  least 1–2 days ahead — we will follow up to confirm.
                </p>

                <div className="mt-7 grid gap-5 sm:grid-cols-2" data-id="element-43" data-mp="maezretcy4oo">
                  <Field label="Full name" htmlFor="name" data-id="element-44" data-mp="r2f5xp00tttp">
                    <input id="name" name="name" required autoComplete="name" className={inputClass} data-id="element-45" data-mp="r3zyxa6ot4pg" />
                  </Field>
                  <Field label="Phone number" htmlFor="phone" data-id="element-46" data-mp="3mp963wibsh45">
                    <input id="phone" name="phone" type="tel" required autoComplete="tel" className={inputClass} data-id="element-47" data-mp="3ioyykfevxin6" />
                  </Field>
                  <Field label="Email" htmlFor="email" data-id="element-48" data-mp="33rge3p98prlj">
                    <input id="email" name="email" type="email" required autoComplete="email" className={inputClass} data-id="element-49" data-mp="33rygz4qer42f" />
                  </Field>
                  <Field label="Year, make & model" htmlFor="vehicle" data-id="element-50" data-mp="38privlkohbww">
                    <input id="vehicle" name="vehicle" className={inputClass} data-id="element-51" data-mp="sylwzswzk262" />
                  </Field>
                  <Field label="What do you need?" htmlFor="service" className="sm:col-span-2" data-id="element-52" data-mp="o13no1f23kxj">
                    <select id="service" name="service" className={inputClass} data-id="element-53" data-mp="2aws1cvinmg9z">
                      <option data-id="element-54" data-mp="2auno3myv84x1">Not sure — please diagnose</option>
                      {services.map(s => <option key={s.name} data-id="element-55" data-mp="21w26pv54qvxu">{s.name}</option>)}
                    </select>
                  </Field>
                  <Field label="Preferred date" htmlFor="date" className="sm:col-span-2" data-id="element-56" data-mp="2pn7ls838xk73">
                    <select id="date" name="date" value={date} onChange={e => {
                  setDate(e.target.value);
                  setSlot(null);
                }} className={inputClass} data-id="element-57" data-mp="2fwmqoums6xsx">
                      {dateOptions.map(d => <option key={d.toISOString()} value={format(d, 'yyyy-MM-dd')} data-id="element-58" data-mp="1d9ragoobi3mg">
                          {format(d, 'EEEE, MMMM d')}
                        </option>)}
                    </select>
                  </Field>
                </div>

                <fieldset className="mt-7" data-id="element-59" data-mp="ym69p1ex0ghp">
                  <legend className="text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/55" data-id="element-60" data-mp="1w7vamtm88sc4">
                    Preferred drop-off time
                  </legend>
                  <div className="mt-3 grid grid-cols-3 gap-2 sm:grid-cols-5" data-id="element-61" data-mp="1r77kea5tofiy">
                    {timeSlots.map(time => {
                  const closed = closedSlots.includes(time);
                  const selected = slot === time;
                  return <button key={time} type="button" disabled={closed} aria-pressed={selected} onClick={() => setSlot(time)} className={`rounded-md border px-2 py-2.5 text-[13px] font-semibold transition-colors duration-150 ease-out ${closed ? 'cursor-not-allowed border-white/5 bg-white/[0.03] text-chalk/25 line-through' : selected ? 'border-brand bg-brand text-white' : 'border-white/15 text-chalk/80 hover:border-brand-light hover:text-white'}`} data-id="element-62" data-mp="aw3kqu6arqnb">
                          {time}
                        </button>;
                })}
                  </div>
                  <p className="mt-3 text-[13px] text-chalk/45" data-id="element-63" data-mp="1fu73mhq5jx7n">
                    Drop-offs 8:00 AM – 4:00 PM. Closed for lunch 12:00 –
                    1:00 PM. Requested slots close out until confirmed.
                  </p>
                </fieldset>

                <button type="submit" className="mt-8 w-full rounded-md bg-white px-6 py-4 font-display text-base font-bold text-ink transition-colors duration-150 ease-out hover:bg-chalk" data-id="element-64" data-mp="3ms0r58dxl4o0">
                  Send appointment request
                </button>
                <p className="mt-3 text-center text-[13px] text-chalk/45" data-id="element-65" data-mp="9je8mdfimyyk">
                  Prefer to talk it through?{' '}
                  <a href={business.phoneHref} className="whitespace-nowrap font-semibold text-brand-light hover:underline" data-id="element-66" data-mp="ehz7a8f4dakw">
                    Call {business.phone}
                  </a>
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}
const inputClass = 'w-full rounded-md border border-white/15 bg-ink px-3.5 py-3 text-[15px] text-white placeholder:text-chalk/35 outline-none transition-colors duration-150 ease-out focus:border-brand-light';
function Field({
  label,
  htmlFor,
  className = '',
  children
}: {
  label: string;
  htmlFor: string;
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={className} data-id="element-67" data-mp="28quwuamj59g2">
      <label htmlFor={htmlFor} className="mb-1.5 block text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/55" data-id="element-68" data-mp="23r8btf0gmowp">
        {label}
      </label>
      {children}
    </div>;
}